import { InsetStatCallout } from '../../../components/ui/inset-stat-callout';
import { MediaHero } from '../../../components/ui/media-hero';
import { SPECIES_GATE_HERO } from './speciesGateAssets';

export function SpeciesSelectorHero() {
  return (
    <MediaHero
      src={SPECIES_GATE_HERO}
      alt='Person smiling while holding a puppy outdoors'
      priority
      footer={
        <InsetStatCallout
          title='5,000+ Matches'
          subtitle='Found their soulmates this month'
        />
      }
    />
  );
}
